import React from 'react';
import { InputController } from '../../../components';
import { Button } from '@mui/material';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

export const GeographyEditForm = ({
  register,
  errors,
  onSubmit,
  handleClose,
  handleSubmit,
  isDirty,
}) => {
  const countryName = useSelector(
    (state: RootState) => state.country.countryName
  );
  const isNonIndia = countryName !== 'India';

  const [openConfirm, setOpenConfirm] =
    React.useState(false);
  const [formData, setFormData] = React.useState(null);
  const handleFormSubmit = (data) => {
    setFormData(data);
    setOpenConfirm(true);
  };
  const handleConfirmSave = () => {
    onSubmit(formData);
    setOpenConfirm(false);
  };
  return (
    <>
      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6 px-6 py-6 pb-24 md:pb-28">
        <InputController
          label="Region"
          register={register('region')}
          error={errors?.region?.message}
          required
          disabled
        />
        <InputController
          label="Sub region"
          register={register('subRegion')}
          error={errors?.subRegion?.message}
          required
          disabled
        />
        <InputController
          label="Sub region code"
          register={register('subRegionCode')}
          error={errors?.subRegionCode?.message}
          required
          disabled
        />
        {isNonIndia && (
          <InputController
            label="Cluster"
            register={register('cluster')}
            error={errors?.cluster?.message}
            required
            disabled
          />
        )}
        <InputController
          label="Village"
          register={register('village')}
          error={errors?.village?.message}
          required
        />

        <div className="col-span-full form-control mt-8 flex justify-end gap-4">
          <Button
            variant="outlined"
            onClick={handleClose}
            size="large"
            sx={{
              color: '#006970',
              borderColor: '#006970',
            }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSubmit(handleFormSubmit)}
            size="large"
            disabled={!isDirty}
            sx={{
              backgroundColor: '#006970',
              '&:hover': { backgroundColor: '#004c52' },
            }}>
            Save
          </Button>
        </div>
      </form>

      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        maxWidth="sm"
        fullWidth>
        <DialogTitle className="flex justify-between items-center">
          Confirm changes
          <IconButton onClick={() => setOpenConfirm(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <p className="text-sm text-gray-600">
            You’re about to save the updated user details.
            Are you sure you want to save changes?
          </p>
        </DialogContent>

        <DialogActions className="px-6 py-4">
          <Button
            variant="outlined"
            onClick={() => setOpenConfirm(false)}
            sx={{
              color: '#006970',
              borderColor: '#006970',
            }}>
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleConfirmSave}
            sx={{
              backgroundColor: '#006970',
              '&:hover': { backgroundColor: '#004c52' },
            }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
